import type { RegistrationGroup } from '../types/content';

export const companyRegistration = [
  { label: 'Registered name', value: 'Liftoff Investments (Pty) Ltd' },
  { label: 'Company registration number', value: 'CO 2007/7072' },
  { label: 'Incorporated', value: 'May 2007, Botswana' },
  { label: 'Registered under', value: 'Companies Registration Act, Chapter 42:01' },
  { label: 'Ownership', value: '100% citizen-owned' },
  { label: 'Contractor profile', value: 'Civil / Structural & Mechanical Contractor' },
];

export const registrationGroups: RegistrationGroup[] = [
  {
    authority: 'PPADB',
    description: 'Public Procurement and Asset Disposal Board registration, as listed in the company profile.',
    rows: [
      { code: '01 – Building', subCode: '01 – Building Construction', grade: 'E' },
      { code: '03 – Civil Engineering', subCode: '10 – Infrastructure – Macro', grade: 'D' },
      { code: '03 – Civil Engineering', subCode: '03 – Roads Construction', grade: 'D' },
      { code: '03 – Civil Engineering', subCode: '23 – Water Supplies – Major', grade: 'E' },
      { code: '03 – Civil Engineering', subCode: '24 – Water Treatment Plants', grade: 'E' },
      { code: '10 – Water Engineering', subCode: '01 – Village Water and Sanitation Works', grade: 'E' },
    ],
  },
  {
    authority: 'Debswana',
    description: 'Debswana Diamond Company vendor registration, as listed in the company profile.',
    rows: [
      { code: 'Debswana registered', subCode: 'Roads and Civil Works', grade: 'Not stated' },
      { code: 'Debswana registered', subCode: 'Structural Steel', grade: 'Unlimited' },
      { code: 'Debswana registered', subCode: 'Building Works', grade: 'Not stated' },
    ],
  },
];
